export const parseBigNumber = (bigNumber: string): number => {
  if (!bigNumber) {
    return 0; // or any default value
  }
  const upperBigNumber = bigNumber.toUpperCase();
  if (upperBigNumber.endsWith("B")) {
    return parseFloat(upperBigNumber) * 1000000000;
  }
  if (upperBigNumber.endsWith("M")) {
    return parseFloat(upperBigNumber) * 1000000;
  }
  if (upperBigNumber.endsWith("K")) {
    return parseFloat(upperBigNumber) * 1000;
  }
  return parseFloat(upperBigNumber);
};
